// @atlas/contracts — a `notifications` modul Zod-sémái
//
// A fájl CSAK sémákat tart (érték-szintű Zod-objektumok + a belőlük inferált típusok) — a ROUTE-ok
// egyetlen `atlasContract` objektum-literálban maradnak (`src/index.ts`), mert a ts-rest
// kontextus-inferenciája a lapos bővítésre érzékeny. A sémák mozgatása ezt NEM érinti: sima értékek.
import { z } from 'zod';
// ── Értesítés-feed („harang") sémák ──
//
// A sor SZÁNDÉKOSAN nem hordoz kész címet/szöveget: a megjelenítést a web rendereli a `type` + `data`
// párból i18n-nel (a legacy `formatNotification()` utódja) — így a nyelvváltás visszamenőleg is hat, és a
// szöveg-javítás nem igényel adat-migrációt. A `resourceRef` LOGIKAI hivatkozás (`atlas:{kind}:{id}`),
// amit a web képez route-ra (`refToRoute`) — az útvonal-átnevezés nem érvényteleníti a régi értesítéseket.
export const NotificationRowSchema = z.object({
    id: z.string(),
    /** A katalógus-kulcs (pl. `ticket.assigned`) — az i18n-kulcs töve + az ikon-választás alapja. */
    type: z.string(),
    /** Megjelenítéshez szükséges, NEM titkos mezők (pl. ticketNumber, accountName, actorName). */
    data: z.record(z.unknown()).nullable(),
    /** `atlas:{kind}:{id}` vagy null (pl. törölt meeting — nincs hova mutatni). */
    resourceRef: z.string().nullable(),
    readAt: z.string().nullable(),
    createdAt: z.string(),
});
export const NotificationListQuerySchema = z.object({
    /**
     * Csak az olvasatlanok. MIÉRT NEM `z.coerce.boolean()`: az MINDEN nem-üres stringet `true`-vá alakít, tehát
     * a `?unreadOnly=false` is szűrne (csendes foot-gun). Ezért explicit allowlist: `1`/`true` → szűr,
     * `0`/`false`/hiányzó → NEM szűr; bármi más 400. (A `boolean` ág a tipizált klienseknek van, a query-string
     * mindig stringet ad.)
     */
    unreadOnly: z
        .union([z.boolean(), z.enum(['0', '1', 'true', 'false'])])
        .optional()
        .transform((v) => v === true || v === '1' || v === 'true'),
    type: z.string().max(200).optional(),
    // Hossz-plafon: a cursor opaque továbbadott érték (a BFF az Odin query-jébe fűzi), tehát a plafon nélkül egy
    // korlátlan hosszú string mehetne át a határon — minden más string-mezőnk plafonos, ez sem lehet kivétel.
    cursor: z.string().max(500).optional(),
    limit: z.coerce.number().int().positive().max(100).optional(),
});
export const NotificationListResponseSchema = z.object({
    data: z.array(NotificationRowSchema),
    nextCursor: z.string().nullable(),
    /**
     * Az OLVASATLANOK száma a badge-hez. A BFF a plafonnál (100) megáll — a 100 tehát „100 vagy több", amit a UI
     * „99+"-ként jelez (`badgeLabel`). A plafon SZÁNDÉKOSAN 100 és nem 99: 99-es plafonnal a „99+" ág soha nem
     * lenne elérhető, és a pontosan 99 olvasatlan is „99+"-ként hazudna.
     */
    unreadCount: z.number(),
});
//# sourceMappingURL=schemas.js.map